

export const RECAPTCHA_SITEKEY  = "6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW";